import { render, staticRenderFns } from "./AddTrainer.vue?vue&type=template&id=3613ee2c"
import script from "./AddTrainer.vue?vue&type=script&lang=js"
export * from "./AddTrainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports